<template>
  <div>
    <vue-headful
    title="Dashboard | Edit Billing Information"
    description="Dashboard | Edit Billing Information"
/>

<div v-if="loading" style="margin: 100px auto;">
  <center>
  <lottie-player src="https://logo.app/lottie/logo-design-loading.json" background="transparent" speed="1" style="width:100%; height:100%; max-width: 500px; max-height: 500px;" loop autoplay></lottie-player>
  <p class="lead">Loading...</p>
  </center>
</div>


    <div v-if="!loading" class="sc-kEYyzF grKTOC">
       <div class="sc-kAdXeD jwoEpG" style="padding: 75px 20px 0px 20px!important;">
          <div class="sc-bvTASY jPMoWD">
             <div class="sc-cFlXAS WflZx">
                <div style="position: relative;">

                <div>
                  <br><br>
                    <h1 style="text-align: center;">Edit Billing Information</h1>
                    <br>
                       <div class="card border-light shadow-soft mb-5" style="max-width: 800px;margin: 0 auto;width: 70%;padding: 10px;">
                          <div class="card-body p-4 p-lg-3">
                                  <div class="row" style="display: flex; flex-wrap: wrap; margin-right: -15px; margin-left: -15px;">
                                      <div class="col-12">
                                          <div class="form-group">
                                              <label class="form-label text-dark">Client Name <span class="text-danger">*</span></label>
                                              <div class="input-group mb-4">
                                                  <div class="input-group-prepend">
                                                      <span class="input-group-text"><i class="fas fa-user-alt"></i></span>
                                                  </div>
                                                  <input v-model="clientname" name="clientname" class="form-control" placeholder="eg. John Doe" type="text">
                                              </div>
                                              <span v-if="clientname === '' && required" class="small" style="color: rgb(237, 80, 79); visibility: visible; position: relative;bottom: 15px;">This field is required.</span>
                                          </div>
                                      </div>
                                      <div class="col-12">
                                          <div class="form-group">
                                              <label class="form-label text-dark">Street Address <span class="text-danger">*</span></label>
                                              <div class="input-group mb-4">
                                                  <div class="input-group-prepend">
                                                      <span class="input-group-text"><i class="fas fa-map-marker-alt"></i></span>
                                                  </div>
                                                  <input v-model="streetaddress" name="address" class="form-control" placeholder="eg. One Infinite Loop" type="address">
                                              </div>
                                              <span v-if="streetaddress === '' && required" class="small" style="color: rgb(237, 80, 79); visibility: visible; position: relative;bottom: 15px;">This field is required.</span>
                                          </div>
                                      </div>
                                      <div class="col-12">
                                          <div class="form-group">
                                              <label class="form-label text-dark">City, State, Country <span class="text-danger">*</span></label>
                                              <div class="input-group mb-4">
                                                  <div class="input-group-prepend">
                                                      <span class="input-group-text"><i class="fas fa-map-marker-alt"></i></span>
                                                  </div>
                                                  <input v-model="location" name="location" class="form-control" placeholder="eg. Cupertino, CA, United States" type="text">
                                              </div>
                                              <span v-if="location === '' && required" class="small" style="color: rgb(237, 80, 79); visibility: visible; position: relative;bottom: 15px;">This field is required.</span>
                                          </div>
                                      </div>
                                      <div class="col-12">
                                          <div class="form-group">
                                              <label class="form-label text-dark">Zip Code <span class="text-danger">*</span></label>
                                              <div class="input-group mb-4">
                                                  <div class="input-group-prepend">
                                                      <span class="input-group-text"><i class="fas fa-map-pin"></i></span>
                                                  </div>
                                                  <input v-model="zipcode" name="zip" class="form-control" placeholder="eg. 95014" type="text">
                                              </div>
                                              <span v-if="zipcode === '' && required" class="small" style="color: rgb(237, 80, 79); visibility: visible; position: relative;bottom: 15px;">This field is required.</span>
                                          </div>
                                      </div>
                                      <div class="col-12">
                                          <div class="form-group">
                                              <label class="form-label text-dark">Phone Number <span class="text-gray">*</span></label>
                                              <div class="input-group mb-4">
                                                  <div class="input-group-prepend">
                                                      <span class="input-group-text"><i class="fas fa-phone"></i></span>
                                                  </div>
                                                  <input v-model="phonenumber" name="phonenumber" class="form-control" placeholder="eg. +1 111 1111111" type="tel">
                                              </div>
                                          </div>
                                      </div>
                                      <div class="text-center" style="margin: 0 auto;">
                                            <button v-if="!loading_edit" @click="guardarbilling" class="btn btn-primary mt-4 animate-up-2"><span class="mr-2"><i class="fas fa-paper-plane"></i></span>Save Billing Information</button>
                                            <button v-if="loading_edit" class="btn btn-primary mt-4 animate-up-2"><span class="mr-2"><i class="fas fa-spinner"></i></span>Loading...</button>
                                        </div>
                                  </div>
                          </div>
                      </div>
                  </div>

             </div>
          </div>
       </div>
    </div>

  </div>

  </div>

</template>

  <script>
  export default {
    data() {
      return {
        loading: true,
        loading_edit: false,
        clientname: '',
        streetaddress: '',
        location: '',
        zipcode: '',
        phonenumber: '',
        required: false
      };
    },
    methods: {
      guardarbilling(){
        this.loading_edit = true;
        axios.post('/dashboard/edit-billing.php', {
          clientname: this.clientname,
          streetaddress: this.streetaddress,
          location: this.location,
          zipcode: this.zipcode,
          phonenumber: this.phonenumber
          })
          .then(response => {
            if(response.data == 'required'){
              this.required = true;
            }
            else{
              this.required = false;
              this.$router.push('/dashboard/billing');
            }
            this.loading_edit = false;
        })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    mounted() {
      this.$emit('updateprops');
      //BILLING
      axios.post('/dashboard/cargar-billing.php', {
        })
        .then(response => {
          this.clientname = response.data[0].clientname;
          this.streetaddress = response.data[0].streetaddress;
          this.location = response.data[0].location;
          this.zipcode = response.data[0].zipcode;
          this.phonenumber = response.data[0].phonenumber;
          this.loading = false;
      })
        .catch(function (error) {
          console.log(error);
        });
    }
  };
  </script>



// WEBPACK FOOTER //
// src/edit-billing.vue